
// initial state
const state = {
  list: [],
};

// getters
const getters = {
};

// actions
const actions = {

};

// mutations
const mutations = {
  setRolesList(state, playload) {
    state.list = playload;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/roles.js